<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10">
            <h5><b>डैशबोर्ड के माध्यम से भुगतान लिंक उत्पन्न करना</b></h5>
            <label for="">एनिमेटेड GIF भुगतान उत्पन्न करने की प्रक्रिया को दर्शाता है
                डैशबोर्ड से सीधे लिंक करें।</label>
        </div>
        <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a></div>
        <div class="col-md-12 mt-3">
            <img src="./assets/GIF/Creating Payment link GIF.gif" width="95%" height="95%"
                alt="" style="border-radius: 10px;">
        </div>

        <div class="col-md-10 col10 mt-2">
            <h2 >पेमेंट लिंक कैसे क्रिएट करें
            </h2>
        </div>

        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='13'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2') "
            (mouseout)="showpayment(false,'2')" id="14">
          
            <h3 >पे जी में भुगतान लिंक बनाने में आमतौर पर निम्नलिखित चरण शामिल
                होते हैं:
                <br><br>

                वेब पर:
            </h3>
            <ol class="mt-3">
              
                <li >पे जी डैशबोर्ड में साइन इन करें, फिर "Create" बटन पर क्लिक
                    करें और फिर "Payment
                    link" पर क्लिक करें। </li>
                <div class="row">
                    <div class="col-md-12 mt-4">
                        <img src="./assets/1.png" width="100%" height="80%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/2.png" width="100%" height="100%" alt="">
                    </div>
                </div>
              
                <li class="mt-5" >आवश्यक विवरण दर्ज करें और फिर “Create
                    payment
                    link” पर क्लिक करें।
                </li>

                <div class="row">
                    <div class="col-md-12 mt-4">
                        <img src="./assets/3.png" width="100%" height="80%" alt="">
                    </div>

                </div>
                               <li class="mt-2" >स्क्रीन पर एक पुष्टिकरण संदेश दिखाया जाएगा और
                    पृष्ठ को अगले पृष्ठ पर पुनः निर्देशित किया जाएगा जहां आप अपना विवरण फिर
                    से जांच सकते हैं और यदि आप आंशिक भुगतान की अनुमति देना चाहते हैं, तो आप
                    दिए गए बॉक्स को चेक कर सकते हैं। </li>
                <div class="row">

                    <div class="col-md-12 mt-3 ">
                        <img src="./assets/4.png" width="100%" height="100%" alt="">
                    </div>
                    <div class="col-md-12 mt-2  ">
                        <img src="./assets/5.png" width="100%" height="100%" alt="">
                    </div>
                </div>

            
                <li class="mt-4" >लिंक सीधे ग्राहक के मोबाइल फोन पर भेजा जाएगा,
                    या आप इसे कॉपी करके ईमेल या अन्य चैट एप्लिकेशन के माध्यम से ग्राहकों को
                    भेज सकते हैं।
                </li>
            </ol>
        </div>
        <div class="col md-12 mt-4" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="15">
            <h5 >मोबाइल ऐप पर: </h5>
            <ul>
               
                <li class="mt-5" >
                    साइन इन करने के बाद, "+" बटन पर क्लिक करें, जो स्क्रीन के नीचे दाईं ओर
                    स्थित है, और पहला विकल्प चुनें जो "Payment Link" है।
                </li>
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/create1.png" alt="" width="40%" height="65%">
                    </div>
                </div>
                
                <li class="mt-3" >
                    आप दिए गए विकल्पों में से किसी एक का चयन कर सकते हैं "Create a detailed
                    payment
                    link" या "Create an Instant payment link"।
                </li>
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/Selected photo (6).jpg" alt="" width="50%"
                            height="65%">
                    </div>
                </div>
       
                <li class="     " >ग्राहक का नाम, ईमेल और मोबाइल नंबर सभी को एक
                    विस्तृत भुगतान लिंक में शामिल किया जा सकता है, जिससे बड़े स्तर पर
                    वैयक्तिकरण की अनुमति मिलती है। इसमें भुगतान का उद्देश्य और लिंक की
                    समाप्ति तिथि और समय भी शामिल है। इस संशोधन के परिणामस्वरूप होने वाला सहज
                    भुगतान अनुभव व्यापारी की वेबसाइट या ब्रांड पहचान के अनुरूप है। आप इस
                    अनुभाग में अपने लिंक भी प्रबंधित कर सकते हैं| </li>
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/Selected photo (7).jpg " alt="" width="50%"
                            height="65%">
                    </div>
                </div>
              
                <li >त्वरित भुगतान लिंक अधिक सरल और तेज़ भुगतान अनुभव के लिए
                    डिज़ाइन किया गया है। इसका उद्देश्य भुगतान प्रक्रिया के दौरान ग्राहक से
                    आवश्यक कदमों और जानकारी को कम करना है। इसमें बस ग्राहक का नाम, राशि और
                    लिंक की समाप्ति तिथि शामिल है। आप इस अनुभाग में भी अपने लिंक प्रबंधित कर
                    सकते हैं| </li>
                <div class="row">
                    <div class="col-md-12 mt-3 text-center">
                        <img src="./assets/Selected photo (8).jpg " alt="" width="50%"
                            height="65%">
                    </div>
                </div>
            </ul>
        </div>
    </div>
</div>
</div>
<div class="col-md-4  hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
           
            <h5 >
                विषयसूची:
            </h5>
        </div>
        <!-- <div class="col-md-12 mt-2">
            <a href="#13"> <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        Creating it on the web </span>
                </div>
            </div></a>
        </div> -->
        <div class="col-md-12 mt-2">
            <a href="#14">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                      
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            इसे वेब पर बनाना </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#15">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                       
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >इसे पे जी मोबाइल ऐप पर बना रहे हैं </span>
                    </div>
                </div>
            </a>
        </div>


    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
           
            <a [routerLink]="['/payment-link']"> <button class="btn btn-color" (click)="menues('Payment Link')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पेमेंट लिंक

            </button></a>
        </div>
        <div class="col-md-4  ">
            
            <a [routerLink]="['/g-store']">  <button class="btn btn-color" (click)="menues('G-Store')" >जी-स्टोर
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
        </div>
    </div>
</div>
</div>